































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'NotFoundRoute',
  metaInfo: {
    title: '404 Not Found',
  },
})
export default class NotFoundRoute extends Vue {}
